import { getSecondsLeft } from "../../../specs/old-product";
import axios from "axios";
import stringify from "qs/lib/stringify";
import { replaceElement } from "../../replaceElement";
import { OldProductSpecMultiUpdater } from "./OldProductSpecMultiUpdater";
import { type IProductSpecItem } from "../..";

export class OldProductSpecItem implements IProductSpecItem {
    shouldAppendToAuctionSocket: boolean = true;
    auctionSocketId: number;
    timer: any;
    specsContainer: any;
    stamp: any;
    constructor({
        auctionSocketId,
        forced,
        timer,
        specsContainer,
    }: {
        auctionSocketId: number;
        forced: boolean;
        timer: any;
        specsContainer: any;
    }) {
        this.auctionSocketId = auctionSocketId;
        this.forced = forced;
        this.timer = timer;
        this.specsContainer = specsContainer;
        const itemType = this.specsContainer.data("itemType");
        this.shouldQueue = itemType === "product";
        this.stamp = this.timer.data("forceTriggerStamp");
        this.timer.removeData("forceTriggerStamp");
        this.boundSetMarkForUpdate = (id, stampData) =>
            this.setMarkForUpdate(id, stampData);
    }
    boundSetMarkForUpdate: (
        id: string,
        stampData: string | null | undefined
    ) => void;
    setMarkForUpdate(id: string, stampData: string | null | undefined): void {
        console.info("Update product " + id);

        const spec = (<any>window).$(
            ".specsToUpdate[data-item-id='{0}'] .countdownTimer".replace(
                "{0}",
                id
            )
        );

        if (stampData != null) {
            spec.data("forceTriggerStamp", atob(stampData));
        }

        spec.data("forceTrigger", "true");
    }
    resetMarkForUpdate() {
        this.timer.removeData("forceTrigger");
    }
    getSecondsLeft(): number {
        return getSecondsLeft(this.timer);
    }
    multiUpdaterType = OldProductSpecMultiUpdater;
    shouldQueue: boolean;
    getRefreshTriggered(): boolean {
        return !!this.timer.data("refreshTriggered");
    }
    setRefreshTriggered(value: boolean): void {
        this.timer.data("refreshTriggered", value);
    }
    forced: boolean;
    getPartialViewName(): string {
        return this.specsContainer.data("partial");
    }
    getIsInList(): boolean {
        const itemId = this.getItemId();
        return (
            this.timer.parents(".auction-productItem[id='" + itemId + "']")
                .length > 0
        );
    }
    getItemId(): any {
        const itemId = this.specsContainer.data("itemId");
        return itemId;
    }
    getItemType(): any {
        return this.specsContainer.data("itemType");
    }
    getOptionalAuctionId(): any {
        return this.specsContainer.find("[name=optionalAuctionId]").val();
    }
    getOptionalAuctionPredefined(): any {
        return (
            this.specsContainer
                .find("[name=optionalAuctionPredefined]")
                .val() || "false"
        );
    }
    getCurrentAuctionId(): any {
        return this.specsContainer.attr("data-auctionid");
    }
    async update() {
        //if (props.itemType == "product" && self.isAuctionProductList == true) return;
        let url = "";
        let data: any = {};

        const itemId = this.getItemId();
        const itemType = this.getItemType();
        const partialViewName = this.getPartialViewName();
        const isInList = this.getIsInList();
        const stamp = this.stamp;
        const optionalAuctionId = this.getOptionalAuctionId();
        const optionalAuctionPredefined = this.getOptionalAuctionPredefined();
        const currentAuctionId = this.getCurrentAuctionId();

        if (itemType == "product") {
            url = "/ajax/SingleProductSpecs/";
            data = {
                id: itemId,
                partialViewName: partialViewName,
                returnNullIfProductInactive: isInList,
                updated: stamp,
            };
            if (optionalAuctionId != null) {
                data.optionalAuctionId = optionalAuctionId;
            }
            if (optionalAuctionPredefined != null) {
                data.optionalAuctionPredefined = optionalAuctionPredefined;
            }
            const currentAuctionIdInt = parseInt(currentAuctionId);
            if (!isNaN(currentAuctionIdInt)) {
                data.currentAuctionId = currentAuctionIdInt;
            }
        } else if (itemType == "auction") {
            url = "/auction/AuctionSpecs/";
            data = { id: itemId, partialViewName: partialViewName };
        }

        if (url == "") return;

        const response = await axios.post(url, stringify(data));

        const result = response.data;

        const itemSpecsElement = this.specsContainer;
        replaceElement(result, itemSpecsElement, itemId, itemType);
    }
}
